module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('abstract-button', {
    staticClass: "mu-tab-link",
    class: {
      'mu-tab-active': _vm.active
    },
    attrs: {
      "href": _vm.href,
      "disabled": _vm.disabled,
      "center-ripple": false
    },
    on: {
      "click": _vm.tabClick
    }
  }, [_vm._t("default", function() {
    return [_c('icon', {
      class: _vm.iconClass,
      attrs: {
        "value": _vm.icon
      }
    })]
  }), _vm._v(" "), (_vm.title) ? _c('div', {
    staticClass: "mu-tab-text",
    class: _vm.textClass
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5084a02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/tabs/tab.vue
// module id = 531
// module chunks = 1